import React from 'react';

import styled, { css } from 'styled-components';
import { GeneralType } from '../../../../types';
import withTheme from '../../utils/styles/theme/withTheme';

type Props = {
  inline?: boolean;
  message: string;
  small?: boolean;
  disabled?: boolean;
  type?: GeneralType;
};

const BadgeWrapper = styled.div<Props>`
  transition: all ease-in-out 0.2s;
  display: ${props => (props.inline ? 'inline-block' : 'block')};
  &:last-child {
    margin-right: 0;
  }

  border-radius: 5px;
  padding: 8px 20px;
  margin-right: 32px;
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;

  background-color: ${({ theme: { colors }, type }) => colors[type].light};
  color: ${({ theme: { colors }, type }) => colors[type].stain};

  ${props =>
    props.small &&
    css`
      padding: 4px 10px;
    `}

  ${props =>
    props.disabled &&
    css`
      background-color: ${({ theme: { colors } }) => colors.gray.stain};
      color: ${({ theme: { colors } }) => colors.gray.light};
    `}
`;

const Badge: React.FC<Props> = ({ message, type = 'gray', ...rest }) => {
  return (
    <BadgeWrapper message={message} type={type} {...rest}>
      {message}
    </BadgeWrapper>
  );
};

export default withTheme(Badge);
